import type { ImageAttachment } from "@/components/panels/image-preview-strip";
import type { DispatchUserMessageResult } from "@/hooks/use-dispatch-user-message";

export function clearAttemptScreenshots(
  images: ImageAttachment[],
  removeImage: (id: string) => void,
): void {
  images.forEach((image) => removeImage(image.id));
}

export function shouldCompleteInputSubmit(
  result: DispatchUserMessageResult,
): boolean {
  return result.sent || result.consumed;
}
